import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  playlistCard: {
    width: '100%',

    '& > .viboImage': {
      aspectRatio: '1/1',

      '& .customLabel': {
        position: 'absolute',
        left: '6px',
        bottom: '6px',

        '@media screen and (min-width: 1441px)': {
          left: '8px',
          bottom: '8px',
        },
      },

      '& .gradient': {
        '& > .viboIcon': {
          fontSize: '80px',
        },
      },
    },

    '& > .viboInputWrapper': {
      margin: '12px 0 24px 0',

      '@media screen and (min-width: 1441px)': {
        margin: '20px 0 36px 0',
      },
    },

    '& > .inputLabel': {
      margin: 0,
      marginTop: '16px',

      '& > .text': {
        margin: 0,
      },

      '& > b': {
        ...mixins.longText,
        maxWidth: 'fit-content',
      },

      '@media screen and (min-width: 1441px)': {
        marginTop: '20px',
      },
    },

    '& .circleDropdown': {
      position: 'absolute',
      top: 0,
      right: 0,
      transform: 'translate(50%,-50%)',
    },

    '@media screen and (min-width: 1441px)': {
      padding: '16px',
    },
  },

  playlistDescription: {
    padding: '0!important',
    lineHeight: '20px',
    margin: '10px 0 6px 0',

    '@media screen and (min-width: 1441px)': {
      lineHeight: '24px',
      margin: '16px 0 8px 0',
    },
  },

  playlistSync: {
    display: 'grid',
    gap: '12px',
    marginTop: '12px',

    '& > .error': {
      position: 'relative',
      fontWeight: 500,
      textAlign: 'center',
    },

    '& .viboButton': {
      width: '100%',

      '&[role="link"]': {
        padding: '0 1px',
        maxWidth: 'fit-content',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '16px',
      marginTop: '16px',
    },
  },

  scrollbar: {
    '& > .contentArea': {
      padding: '12px',

      '@media screen and (min-width: 1441px)': {
        padding: '16px',
      },
    },
  },
}));

export default useStyles;
